import { render, staticRenderFns } from "./TypeaheadList.vue?vue&type=template&id=4f84bb3a&scoped=true&"
import script from "./TypeaheadList.vue?vue&type=script&lang=ts&"
export * from "./TypeaheadList.vue?vue&type=script&lang=ts&"
import style0 from "./TypeaheadList.vue?vue&type=style&index=0&id=4f84bb3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84bb3a",
  null
  
)

export default component.exports